const config = {
  apiHost: 'https://asia-east1-kslplusstaging.cloudfunctions.net/api/v1',
  apiImportLotteries: 'https://stg-lottery-publisher-api.lotteryplus.dev',
  apiImportMysteryBox: 'https://stg-import-mystery-box-api.lotteryplus.dev',
  reportHost: 'https://asia-east1-kslplusstaging.cloudfunctions.net/report',
  urlHost: 'https://asia-east1-kslplusstaging.cloudfunctions.net',
  baseUrlLog: 'https://asia-east1-kslplusstaging.cloudfunctions.net/monitoring',
  baseAPIExists: 'https://kslplus-marketplace-rmo34zjgkq-de.a.run.app',
  newPaymentAPI: 'https://stg-payment-api.lotteryplus.dev',
  urlImageSlip: 'https://payment-status-rmo34zjgkq-de.a.run.app',
  affiliateApiURL: 'https://stg-affiliate-api.lotteryplus.dev',
  orderApiURL: 'https://stg-order-api.lotteryplus.dev',
  apiGateway: 'https://stg-user-api-gateway.lotteryplus.dev',
  apiAdminGateway: 'https://stg-admin-api-gateway.lotteryplus.dev',
  apiAdminWsGateway: 'stg-websocket-api-gateway.lotteryplus.dev',
  dataMatrixDetectionApi: 'https://stg-datamatrix-detection-api.lotteryplus.dev',
  receiverIds: {
    ceo: 'GGrFkdrsYIDwb3vXb1Uz',
    u1: 'pUnAgnpF7yqJJcHC7hQZ',
  },
  firebase: {
    apiKey: 'AIzaSyBn63LPASSlBjFZyC3tzyYKG88evta2wd8',
    authDomain: 'kslplusstaging.firebaseapp.com',
    databaseURL: 'https://kslplusstaging-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'kslplusstaging',
    storageBucket: 'kslplusstaging.appspot.com',
    messagingSenderId: '320552873953',
    appId: '1:320552873953:web:af5d0006b787efaf1daca0',
    measurementId: 'G-37SE31577R',
  },
  fcmKey:
    'AAAASqJwr-E:APA91bHCEGiZsVQGiNbrEeR5boukHGnD6QMjCrLgWLlXVHKzxPX3hOw_PSbb54tFB2rTrpVu5JKKZQA3E1uh8KMo4DGQ0twdquEeH2g6GGCCqRI5tA9lkeDT00EYvGIAKv2m9WNHF85K',
  mongoChart: {
    confirmOrder: '8a808668-6b4c-44c5-882c-1c6d62674780',
    successOrder: '551bf2c2-b755-4037-b72f-daab7f3cd1ba',
    orderDailySeries: '64d4bc06-2bb5-46d3-87e8-8ac1d88797aa',
    orderHourSeries: '51f3a1bc-be6d-49d6-8bed-787c20a36840',
    uniqueUser: '64dc985c-7b80-4ca4-896f-d012cecef559',
    lotteryLast24Hours: '64d60649-0630-4c7f-86cd-9890119a9e7d',
    totalLottery: '64ddbd40-e2f1-46ef-84ba-240a2eea08a7',
    totalBox: '6513c561-57aa-48e1-8480-f22529ab5af4',
    remainLottery: '64ddbced-e2f1-4fd6-81c0-240a2ee9d9b6',
    remainBox: '64ec2afb-7f1b-4164-8539-99a427cd0895',
    remainLotteryInCart: '64ec2c4c-0776-4a03-872e-1229fb0e9e1e',
    publishLottery: '650801c4-73e9-45fc-8fe3-2d4da445e243',

    userDailySeries: '64cc8302-fb38-43ba-8d06-deb7a03e5c27',
    totalUser: '64d366bf-c997-4243-871d-c8dc3c8666d8',
    totalUserLast24Hours: '64d36715-93ac-4c27-893a-8dbe970fadd9',
    orderRoundDateTable: '655c3596-5d06-4a72-8792-76093bf7fd03',
    newUserThisRound: '669a1bb4-ad9a-42ca-85d1-01a806113b0f',
  },
  mongoChartUrl: 'https://charts.mongodb.com/charts-staging-ifsbt',
  newBODashboard: 'https://stg-lotteryplus-backoffice-internal.lotteryplus.dev:8443/dashboard',
}
export default config
